import i18n from 'helpers/i18n';

/**
 * TEMP HACK — "Personality" → "Behavioural" relabel (per-client, temporary).
 *
 * One specific client wants the Personality test presented to candidates as
 * "Behavioural", in English only. Companies are allowlisted on the backend
 * via the PERSONALITY_RELABEL_COMPANY_IDS env var and exposed as
 * `usesBehaviouralLabel` on the company (available via myRole.company).
 *
 * The labels are deliberately hardcoded English strings, NOT translation
 * keys: non-English locales must keep the normal localized "Personality"
 * strings (locale files are managed in Crowdin and this hack must not leak
 * into them).
 *
 * Remove this file and its call sites (grep for it), the GQL field and the
 * monolith counterpart (behavioural-relabel.helper.ts) once the request is
 * retired.
 */

/** Replaces t('common.testTypes.personality') ("Personality"). */
export const BEHAVIOURAL_TEST_SHORT_LABEL = 'Behavioural';

/** Replaces t('test.instructions.personality.name') ("Personality test"). */
export const BEHAVIOURAL_TEST_LONG_LABEL = 'Behavioural test';

export const shouldUseBehaviouralLabel = (
  usesBehaviouralLabel: boolean | undefined
): boolean => Boolean(usesBehaviouralLabel) && i18n.language.startsWith('en');
